export default __webpack_public_path__ + "static/media/TokenPocket.977e38ab.svg";